import React from "react";
import { t } from "ttag";

import { useAppDispatch } from "../../reducers";
import { Actions } from "../actions";
import { ICustomerDetails } from "../models.interfaces";
import { FormView } from "./abstract/FormView";

interface IProps {
    customer: ICustomerDetails;
}

export const CustomerDetailsEdit = (props: IProps) => {
    const dispatch = useAppDispatch();
    const actions = new Actions(dispatch);

    return (
        <FormView
            url={props.customer.url}
            baseURL={"/api/csr/users/"}
            actions={actions}
            fields={[
                {
                    label: t`Username`,
                    name: "username",
                    isRequired: true,
                    type: "text",
                },
                {
                    label: t`First Name`,
                    name: "first_name",
                    placeholder: "",
                    isRequired: false,
                    type: "text",
                },
                {
                    label: t`Last Name`,
                    name: "last_name",
                    placeholder: "",
                    isRequired: false,
                    type: "text",
                },
                {
                    label: t`Email Address`,
                    name: "email",
                    placeholder: "",
                    type: "email",
                },
            ]}
            initialValues={props.customer}
        />
    );
};
